// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"zarejestruj-swoj-ekspres_headerWrapper__tOSfE"};